import type { GetCertificationsListRes } from "./-query/type";

type CertificationsTableRow = GetCertificationsListRes["items"][number];

// Certifications テーブルの列定義
export const Columns = {
  CERTIFICATION_ID: "certificationId",
  CERTIFICATION_NAME: "certificationName",
  CERTIFICATION_PARTY: "certificationParty",
  EFFECTIVE_DATE: "effectiveDate",
  EXPIRATION_DATE: "expirationDate",
  RENEWAL_DATE: "renewalDate",
  CERTIFICATION_HOLDER: "certificationHolder",
} as const satisfies Record<string, keyof CertificationsTableRow>;
